import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input,Select } from 'antd'

import { Page,Crud } from '../../components'

const Option = Select.Option
const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class SalaryRangePage extends Component {
  static propTypes = {
    system: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
     const { salaryRangePage,currentSalaryRange} = this.props.system;
     const { getAllSalaryType} = this.props.actions;
     getAllSalaryType();
     this.fetchList( salaryRangePage);
  }

  fetchList = (page,values) => {
    const {getSalaryRangeList} = this.props.actions;
    let params = Object.assign({},{page:page},values)
    getSalaryRangeList(params);
  }

  getDataSource() {
    const { system } = this.props;
    const { salaryRangeById, salaryRangeList } = system;
    if (!salaryRangeList) return [];
    return salaryRangeList.map(id => salaryRangeById[id]);
  }

  get listProps() {
    const { system,actions } = this.props
    const { getSalaryRangeListPending,salaryRangeTotal,salaryRangePage,allsalaryTypeById,allsalaryTypeList } = system
    const { deleteSalaryRange,chooseCurrentSalaryRange,salaryRangeModalChange } = actions;

    return {
      dataSource: this.getDataSource(),
      loading: getSalaryRangeListPending,
      columns:[
        {
          title: "薪资类别",
          dataIndex: 'salaryTypeId',
          key: 'salaryTypeId',
          width: 180,
          render: text => {
              console.log(allsalaryTypeById);
              if (allsalaryTypeById[text] != undefined){
                return <span>{allsalaryTypeById[text].name}</span>
              }else{
                  return <div></div>
              }
          },
        },
        {
          title: "薪资范围",
          width: 180,
          render: record => {
              console.log(record);
            return <span>{record.rangeStart/100}--{record.rangeEnd/100}</span>
          },
        },
        {
          title: "排序号",
          dataIndex: 'orderNum',
          key: 'orderNum',
          width: 180,
        },
      ],
      pagination:{
        total:salaryRangeTotal,
        current:salaryRangePage,
        onChange : (page) => {
          this.fetchList(page);
        }
      },
      op:[
       {
          key:1,
          name:'编辑',
          buttonProps:{
            icon:"edit",
            type:"primary"
          },
        },
        {
          key:3,
          name:'删除',
          buttonProps:{
            icon:"delete",
            type:"danger"
          },
          needConfirm:true,
          confirmTitle:"确认删除"
        }
      ],
      handleMenuClick: (record,item) => {
        if (item.key == 1){
          chooseCurrentSalaryRange(record);
          salaryRangeModalChange(true,"updata");
        }else if(item.key == 3){
            deleteSalaryRange(record.id).then((data) => {
            this.fetchList(salaryRangePage);
          })
        }
      }
    }
  } 

  getType = () => {
        const {system} = this.props;
        const {allsalaryTypeById,allsalaryTypeList} = system
        return allsalaryTypeList.map(id => allsalaryTypeById[id]).map(item => (
            <Option key={item.id}>{item.name}</Option>
        ))
    }

  get modalProps() {
    const { system,actions } = this.props
    const { currentSalaryRange, salaryRangeModalVisible,salaryRangePage, salaryRangeModalType,submitSalaryRangePending } = system

    const { salaryRangeModalChange,submitSalaryRange } = actions;
    const editItem  = salaryRangeModalType === 'create' ? {} : currentSalaryRange
    return {
      item: salaryRangeModalType === 'create' ? {} : currentSalaryRange,
      visible: salaryRangeModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitSalaryRangePending,
      title: `${
        salaryRangeModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
            key: "salaryTypeId",
            label: "薪资类别",
            initialValue: editItem.salaryTypeId?`${editItem.salaryTypeId}`:editItem.salaryTypeId,
            widget: Select,
            children:this.getType(),
            required: true
        },
        {
          key: "rangeStart",
          label: "最低",
          initialValue: editItem.rangeStart?editItem.rangeStart/100:"",
          widget: Input,
          required: true
        },
        {
          key: "rangeEnd",
          label: "最高",
          initialValue: editItem.rangeEnd?editItem.rangeEnd/100:"",
          widget: Input,
          required: true
        },
        {
          key: "orderNum",
          label: "排序号",
          initialValue: editItem.orderNum,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        submitSalaryRange(Object.assign({},data,{rangeStart:data.rangeStart*100,rangeEnd:data.rangeEnd*100})).then(data=> {
          salaryRangeModalChange(false,"create");
          this.fetchList(salaryRangePage);
        })
      },
      onCancel() {
        salaryRangeModalChange(false,"create");
      },
    }
  }

  get filterProps() {
    const { actions,system } = this.props
    const { currentSalaryRange,salaryRangePage} = system
    const { salaryRangeModalChange } = actions;

    return {
      title:"",
      searchElements: [
        {
            key: "loginId",
            widget: Input,
            widgetProps:{
                placeholder:"请输入登录名"
            },
        },
      ],
      onFilterChange: value => {
         this.fetchList(1,value)
      },
      onAdd() {
        salaryRangeModalChange(true,'create')
      },
    }
  }

  get buttonProps() {
    const { actions,system } = this.props
    const { currentSalaryRange,salaryRangePage} = system
    const { salaryRangeModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ salaryRangeModalChange(true,'create')}
            }
        ]
    }
  }

  render() {
    return (
      <Page inner>
        {/* <CrudFilter {...this.filterProps} /> */}
        <CrudButtons {...this.buttonProps} />
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    system: state.system,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalaryRangePage);


// WEBPACK FOOTER //
// ./src/features/system/SalaryRangePage.js